import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  visitorDetail,
  visitorFormUpdate,
} from "reduxStore/action/visitorActions";
import { getPropertyDetail } from "reduxStore/action/propertyActions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  seo,
  handleDetailResponse,
  handleListResponse,
  minORmaxAmountValid,
  minORmaxAmountEmiValid,
  minORmaxValid,
} from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import { getConfiguration } from "reduxStore/action/masterActions";
import { getAgentProperty } from "reduxStore/action/propertyActions";

const EditVisitor = () => {
  const navigate = useNavigate();
  const leadId = new URLSearchParams(window.location.search).get("lead_id");
  const [form, setForm] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const [viewDetails, setViewDetails] = useState({});
  const dispatch = useDispatch();
  const [configurationsType, setConfigurationsType] = useState([]);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const configurationsSelector = useSelector((state) => state.configurations);

  const visitorDetailSelector = useSelector((state) => state.visitor);

  const visitorDataSelector = useSelector((state) => state.visitorForm);

    const getPropertyDetailSelector =
      useSelector((state) => state.propertyData);

      useEffect(() => {
        if(form.property_id){
          dispatch(getPropertyDetail({ property_id: form.property_id }));
      }
        }, [dispatch, form.property_id]);

      useEffect(() => {
          if (getPropertyDetailSelector.detail) {
            const { response } = getPropertyDetailSelector;
            if (response?.status === 200) {
             
              setViewDetails(handleDetailResponse(response?.data));
            } else {
              setViewDetails({});
            }
          }
        }, [getPropertyDetailSelector]);

  useEffect(() => {
    if ( visitorDataSelector.detail) {
      dispatch(visitorFormUpdate(form));
    }
    if (visitorDataSelector.update) {
      setForm({ ...visitorDataSelector.response });
    }
    // return () => dispatch(visitorFormUpdate(null))
  }, [visitorDataSelector]);

  useEffect(() => {
    if (leadId) {
      dispatch(visitorDetail({ lead_id: leadId }));
    } else {
      // dispatch(visitorFormUpdate(form));
    }
  }, []);

  useEffect(() => {
    if (configurationsSelector.response) {
      const { response } = configurationsSelector;
      if (response?.status === 200) {
        if (viewDetails && viewDetails.configuration_area) {
          const configurationIds = viewDetails.configuration_area.map(item => item.configuration_id);
  
          // Filter configurations that match the extracted configuration_ids
          const filteredConfigurations = response.data.filter(config => configurationIds.includes(config._id));
  
          // Set the filtered configurations
          setConfigurationsType(filteredConfigurations);
        } else {
          // Handle case where configuration_area is undefined or null
          
          setConfigurationsType([]);
        }
      } else {
        setConfigurationsType([]);
      }
    }
  }, [configurationsSelector, viewDetails]);

  useLayoutEffect(() => {
    dispatch(getConfiguration());
  }, []);

  // useEffect(() => {
  //   dispatch(getAgentProperty());
  // }, []);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  useEffect(() => {
    if (visitorDataSelector.detail) {
      const { response } = visitorDataSelector;
      if (response?.status === 200) {
        const result = handleDetailResponse(response?.data);
        setForm({
          ...form,
          lead_id:result?.lead_id,
          create_by: result?.create_by,
          property_title: result?.property_title,
          property_id: result?.property_id,
          lead_source: result?.lead_source_id,
          cp_emp_id: result?.cp_emp_id,
          cp_id: result?.cp_id,
          configuration: result?.configuration,
          configuration_id: result?.configuration_id,
          expected_possession_date: result?.expected_possession_date
            ? moment(result?.expected_possession_date).format("YYYY-MM-DD")
            : null,
          preferred_bank: result?.customer_detail?.preferred_bank,
          property_type: result?.customer_detail?.property_type,
          areain_sqlft: result?.areain_sqlft,
          min_budget: result?.min_budget,
          min_emi_budget: result?.min_emi_budget,
          max_budget: result?.max_budget,
          max_emi_budget: result?.max_emi_budget,
          min_budget_type: result?.min_budget_type,
          min_emi_budget_type: result?.min_emi_budget_type,
          max_budget_type: result?.max_budget_type,
          max_emi_budget_type: result?.max_emi_budget_type,
          funding_type: result?.funding_type,
          purpose: result?.purpose,
          first_name: result?.customer_detail?.first_name,
          last_name: result?.customer_detail?.last_name,
          marital_status: result?.customer_detail?.marital_status,
          adhar_no: result?.customer_detail?.adhar_no,
          pancard_no: result?.customer_detail?.pancard_no,
          current_stay: result?.customer_detail?.current_stay,
          no_of_family_member: result?.customer_detail?.no_of_family_member,
          gender: result?.customer_detail?.gender,
          birth_date: result?.customer_detail?.birth_date
            ? moment(result?.customer_detail?.birth_date).format("YYYY-MM-DD")
            : null,
          mobile: result?.customer_detail?.mobile,
          whatsapp_no: result?.customer_detail?.whatsapp_no,
          email: result?.customer_detail?.email,
          location: result?.customer_detail?.location,
          locality: result?.customer_detail?.locality,
          occupation: result?.customer_detail?.occupation,
          desigantion: result?.customer_detail?.desigantion,
          coumpany_name: result?.customer_detail?.coumpany_name,
          office_address: result?.customer_detail?.office_address,
          cp_lead_type:result?.cp_lead_type,
          referrel_partner:result?.referrel_partner
        });
      }
    }
  }, [visitorDetailSelector]);

  const checkBudget = (value = "") => {
    return value ? value : "";
  };
  const checkBudgetType = (value = "") => {
    return value ? value : "L";
  };

  const handleNext = () => {
    if (!handleValid()) {
   
      form.min_budget = checkBudget(form.min_budget);
      form.max_budget = checkBudget(form.max_budget);
      form.min_budget_type = checkBudgetType(form.min_budget_type);
      form.max_budget_type = checkBudgetType(form.max_budget_type);
      form.min_emi_budget = checkBudget(form.min_emi_budget);
      form.max_emi_budget = checkBudget(form.max_emi_budget);
      form.min_emi_budget_type = checkBudgetType(form.min_emi_budget_type);
      form.max_emi_budget_type = checkBudgetType(form.max_emi_budget_type);
      // form.mobile = "";
      // form.cp_id = "";
      // form.cp_emp_id = "";
      // form.property_id = "";
      // form.first_name = "";
      // form.cp_type = ""
      // form.lead_source = ""
      // form.referrer_contact = ""
      // form.referrer_name = ""
      // console.log("dorm",form)
      dispatch(visitorFormUpdate(form));
      let leadID = leadId ? "?lead_id=" + leadId : "";
      navigatpage("/visitor_form_third" + leadID);
    }
  };


  const handleValid = () => {
    let err = {};
    let formError = false;
    if (
      form.min_budget &&
      form.max_budget &&
      (!form.min_budget_type || !form.max_budget_type)
    ) {
      formError = true;
      err["amountErr"] = strings.amountTypeErr;
    }
    if (
      form.min_emi_budget &&
      form.max_emi_budget &&
      (!form.min_emi_budget_type || !form.max_emi_budget_type)
    ) {
      formError = true;
      err["emiAmountErr"] = strings.amountTypeErr;
    }
    if (
      !minORmaxAmountValid(
        form.min_budget,
        form.max_budget,
        form.min_budget_type,
        form.max_budget_type
      )
    ) {
      formError = true;
      err["amountErr"] = strings.amountEror;
    }
    if (
      !minORmaxAmountEmiValid(
        form.min_emi_budget,
        form.max_emi_budget,
        form.min_emi_budget_type,
        form.max_emi_budget_type
      )
    ) {
      formError = true;
      err["emiAmountErr"] = strings.amountEror;
    }
    if (minORmaxValid(form.min_budget, form.max_budget) === 1) {
      formError = true;
      err["amountErr"] = strings.amountMaxEror;
    }
    if (minORmaxValid(form.min_budget, form.max_budget) === 2) {
      formError = true;
      err["amountErr"] = strings.amountMinEror;
    }
    if (minORmaxValid(form.min_emi_budget, form.max_emi_budget) === 1) {
      formError = true;
      err["emiAmountErr"] = strings.amountMaxEmiEror;
    }
    if (minORmaxValid(form.min_emi_budget, form.max_emi_budget) === 2) {
      formError = true;
      err["emiAmountErr"] = strings.amountMinEmiEror;
    }
    setFormVaild(err);

    return formError;
  };

  function validateMaxEmiAgainstBudget( max_budget, max_emi_budget) {
    // Convert to number
    const maxBudget = parseFloat(max_budget) || 0;
    const maxEmiBudget = parseFloat(max_emi_budget) || 0;
  
    if (maxEmiBudget > maxBudget) {
      return 'Max EMI cannot be greater than min or max budget';
    }
    return null;
  }
  

  useEffect(() => {
    seo({
      title: "Visitor Form",
      metaDescription: "Visitor_form",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={leadId ? strings.editvisitor : strings.addNewVisitor}
        url={"/visitor"}
        parentListing={strings.visitorList}
        titleactive={leadId ? strings.editVisitor : strings.addNewVisitor}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{leadId ? strings.editvisitor : strings.addNewVisitor}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.configuration}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="configuration_id"
                          value={form.configuration_id}
                          onChange={(e) => {
                            var index = e.target.selectedIndex;
                            var configuration =
                              e.target[index].text;
                            const nextFormState = {
                              ...form,
                              configuration_id: e.target.value,
                              configuration: configuration,
                            };
                            setForm(nextFormState);
                          }}
                        >
                          <option value={""}>
                            {strings.selectConfiguration}
                          </option>
                          {configurationsType.length > 0 ? (
                            configurationsType.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option></option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.expectedPossesionDate}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="expected_possession_date"
                          value={form.expected_possession_date}
                          placeholder={strings.expectedPossesionDate}
                          onChange={handleInputField}
                          min={moment().add(1, "days").format("yyyy-MM-DD")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-8 ">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.propertyType}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="property_type"
                          value={form.property_type}
                          onChange={handleInputField}
                        >
                          <option defaultValue={null}>
                            {strings.selectPropType}
                          </option>
                          <option value={1}>{strings.moveIn}</option>
                          <option value={2}>{strings.underConstruction}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.Area}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="number"
                          name="areain_sqlft"
                          value={form.areain_sqlft}
                          onChange={handleInputField}
                          placeholder={strings.Area}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 10) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 row">
                      <div className="col-md-4">
                        <div className="mb-2">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.minBudget}
                          </label>
                          <div className="d-flex flex-direction-row">
                            <input
                              className="form-control digits"
                              id="exampleFormControlInput1"
                              type="number"
                              maxLength={4}
                              autoComplete="off"
                              name="min_budget"
                              value={form.min_budget}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountValid(
                                  e.target.value,
                                  form.max_budget,
                                  form.min_budget_type,
                                  form.max_budget_type
                                );
                                if (e.target.value !== "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: null,
                                  });
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 4) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              id="exampleFormControlSelect9"
                              name="min_budget_type"
                              value={form.min_budget_type}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountValid(
                                  form.min_budget,
                                  form.max_budget,
                                  e.target.value,
                                  form.max_budget_type
                                );
                                if (e.target.value !== "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: null,
                                  });
                                }
                              }}
                            >
                              <option value={""}>₹</option>
                              <option value={"L"}>L</option>
                              <option value={"C"}>Cr</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 ml-4">
                        <div className="mb-2">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.maxBudget}
                          </label>
                          <div className="d-flex flex-direction-row">
                            <input
                              className="form-control digits"
                              id="exampleFormControlInput1"
                              type="number"
                              autoComplete="off"
                              name="max_budget"
                              value={form.max_budget}
                              onChange={(e) => {
                                handleInputField(e);

                               

                                const err = minORmaxAmountValid(
                                  form.min_budget,
                                  e.target.value,
                                  form.min_budget_type,
                                  form.max_budget_type
                                );
                                if (e.target.value !== "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: null,
                                  });
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 4) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              id="exampleFormControlSelect9"
                              name="max_budget_type"
                              value={form.max_budget_type}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountValid(
                                  form.min_budget,
                                  form.max_budget,
                                  form.min_budget_type,
                                  e.target.value
                                );
                                if (e.target.value !== "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: null,
                                  });
                                }
                              }}
                            >
                              <option value={""}>₹</option>
                              <option value={"L"}>L</option>
                              <option value={"C"}>Cr</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {formVaild?.amountErr && (
                    <span style={{ color: "red" }}>{formVaild?.amountErr}</span>
                  )}
                  <div className="row">
                    <div className="col-md-12 row">
                      <div className="col-md-4">
                        <div className="mb-2">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.minEMIpay}
                          </label>
                          <div className="d-flex flex-direction-row">
                            <input
                              className="form-control digits"
                              id="exampleFormControlInput1"
                              type="number"
                              autoComplete="off"
                              name="min_emi_budget"
                              value={form.min_emi_budget}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountEmiValid(
                                  e.target.value,
                                  form.max_emi_budget,
                                  form.min_emi_budget_type,
                                  form.max_emi_budget_type
                                );
                                if (e.target.value !== "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: null,
                                  });
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 4) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              id="exampleFormControlSelect9"
                              name="min_emi_budget_type"
                              value={form.min_emi_budget_type}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountEmiValid(
                                  form.min_emi_budget,
                                  form.max_emi_budget,
                                  e.target.value,
                                  form.max_emi_budget_type
                                );
                                if (e.target.value !== "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: null,
                                  });
                                }
                              }}
                            >
                              <option value={""}>₹</option>
                              <option value={"K"}>K</option>
                              <option value={"L"}>L</option>
                              <option value={"C"}>Cr</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 ml-4">
                        <div className="mb-2">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.maxEMIpay}
                          </label>
                          <div className="d-flex flex-direction-row">
                            <input
                              className="form-control digits"
                              id="exampleFormControlInput1"
                              type="number"
                              autoComplete="off"
                              name="max_emi_budget"
                              value={form.max_emi_budget}
                              onChange={(e) => {
                                handleInputField(e);

                                const emiAmountErr = validateMaxEmiAgainstBudget(
                                  form.max_budget,
                                  e.target.value,
                                  form.max_emi_budget_type
                                );
                  
                                const err = minORmaxAmountEmiValid(
                                  form.min_emi_budget,
                                  e.target.value,
                                  form.min_emi_budget_type,
                                  form.max_emi_budget_type
                                );
                                if (e.target.value !== "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: strings.amountEror,
                                  });
                                }else if (emiAmountErr) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: emiAmountErr,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: null,
                                  });
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 4) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              id="exampleFormControlSelect9"
                              name="max_emi_budget_type"
                              value={form.max_emi_budget_type}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountEmiValid(
                                  form.min_emi_budget,
                                  form.max_emi_budget,
                                  form.min_emi_budget_type,
                                  e.target.value
                                );
                                if (e.target.value !== "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: null,
                                  });
                                }
                              }}
                            >
                              <option value={""}>₹</option>
                              <option value={"K"}>K</option>
                              <option value={"L"}>L</option>
                              <option value={"C"}>Cr</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {formVaild?.emiAmountErr && (
                    <span style={{ color: "red" }}>
                      {formVaild?.emiAmountErr}
                    </span>
                  )}
                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.preferredBank}
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary mr-5">
                              <input
                                id="radioinline14"
                                type="radio"
                                name="preferred_bank"
                                value={"Yes"}
                                checked={
                                  form.preferred_bank === "Yes" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline14">
                                {strings.yes}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-5">
                              <input
                                id="radioinline15"
                                type="radio"
                                name="preferred_bank"
                                value={"No"}
                                checked={
                                  form.preferred_bank === "No" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline15">
                                {strings.no}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row pt-2">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName1">
                          {strings.natureOffunding}
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary mr-5">
                              <input
                                id="radioinline1"
                                type="radio"
                                name="funding_type"
                                value={"loan"}
                                checked={
                                  form.funding_type === "loan" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline1">
                                {strings.loan}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-5">
                              <input
                                id="radioinline2"
                                type="radio"
                                name="funding_type"
                                value={"self"}
                                checked={
                                  form.funding_type === "self" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline2">
                                {strings.selfFunding}
                              </label>
                            </div>
                            <div className="radio radio-primary ml-5">
                              <input
                                id="radioinline3"
                                type="radio"
                                name="funding_type"
                                value={"both"}
                                checked={
                                  form.funding_type === "both" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline3">
                                {strings.both}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.Purpose}
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary mr-5">
                              <input
                                id="radioinline4"
                                type="radio"
                                name="purpose"
                                value={"end user"}
                                checked={
                                  form.purpose === "end user" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline4">
                                {strings.endUser}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-5">
                              <input
                                id="radioinline5"
                                type="radio"
                                name="purpose"
                                value={"invest"}
                                checked={
                                  form.purpose === "invest" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline5">
                                {strings.invesment}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="button"
                          onClick={() => handleNext()}
                        >
                          {strings.next}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditVisitor;
